import React, { useState, useEffect, useMemo } from "react";

// table(components)
import BoostrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import styled from "styled-components";
import { getCellStyle, GetHeaderStyle } from "../../core/Helper";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { AiOutlineMinus } from "react-icons/ai";
import { GetCreateTable } from "../../core/Helper2";

function StudyParts(props) {
  const [data, setData] = props.priceData;
  const [dataRem, setDataRem] = props.priceDataRemove;
  const [importantEdit, setImportantEdit] = props.updateImportant;
  const [flag, setFlag] = useState(false);

  /** --------------------------------------------------------------- */
  const actionPriceChange = async (oldValue, newValue, row, column, done) => {
    if (column?.dataField === "qty") {
      row.total = newValue * row.price;
    }
    done();
  };

  /** --------------------------------------------------------------- */
  const formatEdit = (cell, row, rowIndex) => {
    return (
      <OverlayTrigger
        placement="top"
        overlay={(props) => <Tooltip {...props}>ใช้</Tooltip>}
      >
        <BtnRemove
          variant="danger"
          onClick={() => {
            removeRow(row, rowIndex);
          }}
        >
          <AiOutlineMinus style={{ marginLeft: "-8px", marginTop: "-15px" }} />
        </BtnRemove>
      </OverlayTrigger>
    );
  };
  /** --------------------------------------------------------------- */
  const columns = useMemo(
    () => [
      {
        dataField: "goodcode",
        text: "รหัส",
        sort: true,
        headerStyle: () => GetHeaderStyle("120px", "left"),
        style: { border: "none", color: "var(--table-text-color)" },
        headerSortingStyle: { border: "none" },
        editable: false,
      },
      {
        dataField: "goodname",
        text: "ชื่อรายการ",
        sort: true,
        headerStyle: GetHeaderStyle("auto", "left"),
        style: getCellStyle("left", "var(--table-text-color)"),
        editable: true,
      },
      {
        dataField: "qty",
        text: "QTY",
        sort: true,
        headerStyle: GetHeaderStyle("50px", "center"),
        style: getCellStyle("center"),
        editable: true,
      },
      {
        dataField: "price",
        text: "ราคา/หน่วย",
        sort: true,
        headerStyle: GetHeaderStyle("150px", "right"),
        style: getCellStyle("right", "var(--table-text-color)"),
        editable: false,
        formatter: toCurrency,
      },
      {
        dataField: "total",
        text: "รวม",
        sort: true,
        headerStyle: GetHeaderStyle("150px", "right"),
        style: getCellStyle("right", "var(--table-text-color)"),
        editable: false,
        formatter: toCurrency,
      },
      {
        dataField: "action_event",
        text: "สถานะ",
        headerStyle: () => GetHeaderStyle("60px"),
        style: { border: "none", color: "var(--table-text-color)" },
        formatter: formatEdit,
        align: "center",
        editable: false,
      },
    ],
    [data]
  );

  // ** ลบแถว
  const removeRow = (row, rowIndex) => {
    if (row.item_id > 0) {
      setDataRem((pv) => [...pv, { ...row, del_flag: "y" }]);
    }
    // ** Delete Unwanted row
    data.splice(rowIndex, 1);
    setData(data);
    setImportantEdit((pv) => {
      pv.changedItem = true;
      return { ...pv };
    });
    setFlag(!flag);
  };

  // useEffect(() => {
  //   console.log(importantEdit);
  // }, [importantEdit]);

  /** --------------------------------------------------------------- */
  return (
    <div>
      <BoostrapTable
        bootstrap4
        keyField="price_list_det_id"
        data={data && data}
        columns={columns}
        striped
        hover
        condensed
        rowClasses="table-next-rows-style"
        headerWrapperClasses="headerWrapper"
        wrapperClasses="table-wrapper-zero-height"
        bordered={true}
        cellEdit={cellEditFactory({
          mode: "click",
          blurToSave: true,
          beforeSaveCell: actionPriceChange,
        })}
      />
    </div>
  );
}

export default React.memo(StudyParts);

const BtnRemove = styled(Button)`
  width: 18px;
  height: 25px;
  border-radius: 20px 20px 20px 20px;
  &:hover {
    background-color: yellow;
    color: black;
    transform: rotate((20deg));
  }
`;

const toCurrency = (cell, row) => {
  return Number(cell).toLocaleString("th-TH", {
    style: "decimal",
    minimumFractionDigits: 2,
  });
};
